module.exports = __webpack_public_path__ + "static/img/Montigo_logo.2ff2654.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Montigo_logo.png
// module id = j3dv
// module chunks = 0